/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import TextFields from '../common/components/TextField/TextField';
import TextFieldsPhone from '../common/components/TextField/TextFieldPhone';
import Link from '../common/Link';
import { useAuth } from '../context/auth-context';

import { registerUser } from '../modules/register/services/register';

const resetError = {
    email: {
        hasError: false,
        message: '',
    },
    password: {
        hasError: false,
        message: '',
    },
    name: {
        hasError: false,
        message: '',
    },
    lastName: {
        hasError: false,
        message: '',
    },
    phone: {
        hasError: false,
        message: '',
    },
    code: {
        hasError: false,
        message: '',
    },
    terms: {
        hasError: false,
        message: '',
    },
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const FormSignUp = (): JSX.Element => {
    const [error, setError] = useState(resetError);
    const [errorRegister, setErrorRegister] = useState('');
    const query = useQuery();
    const name = query.get('name');
    const lastName = query.get('lastName');
    const email = query.get('email');
    const phone = query.get('phone');
    const terms = query.get('terms');
    const [values, setValues] = useState({
        name: name ? name : '',
        lastName: lastName ? lastName : '',
        email: email ? email : '',
        password: '',
        phone: phone ? phone : '',
        code: '',
        terms: terms === 'true' ? true : false,
    });

    const auth = useAuth();
    const router = useHistory();

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };

    const handleRegister = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        //console.log('llegue');
        if (values && values.password === '') {
            setError({
                ...error,
                password: {
                    hasError: true,
                    message: '¡Contraseña es requerida!',
                },
            });
        }

        if (values && values.password !== '' && values.password.length < 8) {
            setError({
                ...error,
                password: {
                    hasError: true,
                    message: '¡Contraseña debe al menos de 8 caracteres!',
                },
            });
        }

        if (values && values.password !== '' && values.password.length < 8) {
            setError({
                ...error,
                password: {
                    hasError: true,
                    message: '¡Contraseña debe al menos de 8 caracteres!',
                },
            });
        }

        if (values && values.email === '') {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: '¡Email es requerido!',
                },
            });
        }

        if (values && values.email !== '' && !validateEmail(values.email)) {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: '¡Email no es valido!',
                },
            });
        }

        try {
            if (
                values &&
                values.email !== '' &&
                values.password !== '' &&
                values.phone !== '' &&
                values.lastName !== '' &&
                values.name !== ''
            ) {
                let user = null;
                delete values.code;
                delete values.terms;
                user = await registerUser(values);

                if (user) {
                    router.push('registro/codigo?email=' + values.email);
                }

                setError(resetError);
            }
        } catch (error) {
            setErrorRegister('');
            if (error.response?.data?.statusCode === 'USER_PASSWORD_INVALID') {
                setErrorRegister(
                    '¡La contraseña es debil!, debe tener al menos 8 carácteres, entre ellos números, letras y al menos una mayúscula',
                );
                return;
            }

            if (error.response?.data?.statusCode === 'USER_ALREADY_EXISTS') {
                setErrorRegister('¡Ya existe un usuario con este correo!, por favor verifique y use otro');
                return;
            }

            console.log({ error });
            setErrorRegister('¡No se puede registrar el usuario, intente nuevamente!');
        }
    };

    const handleChangeEmail = (e: any) => {
        setErrorRegister('');
        setError({
            ...error,
            email: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, email: e.target.value.trim() });
    };

    const handleChangeName = (e: any) => {
        setErrorRegister('');
        setError({
            ...error,
            name: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, name: e.target.value });
    };

    const handleChangeLastName = (e: any) => {
        setErrorRegister('');
        setError({
            ...error,
            lastName: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, lastName: e.target.value });
    };

    const handleChangePhone = (e: any) => {
        setErrorRegister('');
        setError({
            ...error,
            phone: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, phone: e.target.value.trim() });
    };

    const handleChangePassword = (e: any) => {
        setErrorRegister('');
        setError({
            ...error,
            password: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, password: e.target.value });
    };

    const handleChangeTerms = () => {
        setErrorRegister('');
        setError({
            ...error,
            terms: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, terms: !values.terms });
    };

    useEffect(() => {
        if (auth.error) {
            console.log('error', auth.error, auth.error.statusCode);
            if (auth.error.statusCode === 'NotAuthorizedExceptionConfirmed') {
                setErrorRegister('Error: Este usuario ya se encuentra CONFIRMADO, haz click en ¿Ya tienes cuenta?');
            } else if (auth.error.statusCode === 'InvalidParameterException') {
                setErrorRegister(
                    'Error: Parametros incorrectos, vuelva a ingresar el email y el codigo enviado a su correo',
                );
            } else if (auth.error.statusCode === 'UserNotConfirmedException') {
                setErrorRegister('Error: Usuario no Confirmado');
            } else if (auth.error.statusCode === 'CodeMismatchException') {
                setErrorRegister('Error: Codigo Invalido');
            } else {
                setErrorRegister('Error: Vuelva Intentar');
            }
        } else {
            setErrorRegister('');
        }
    }, [auth]);

    useEffect(() => {
        //console.log(values.terms, 'aqui');
    }, [values.terms]);

    useEffect(() => {
        setErrorRegister('');
        setError(resetError);
        auth.clearStateChangePassword();
        auth.clearErrorAuth();
    }, []);

    useEffect(() => {
        setValues({
            name: name ? name.trim() : '',
            lastName: lastName ? lastName.trim() : '',
            email: email ? email.trim() : '',
            phone: phone ? phone.trim() : '',
            terms: terms === 'true' ? true : false,
            code: '',
            password: '',
        });
    }, [name, lastName, email, phone, terms]);

    return (
        <>
            <form className="flex flex-col mb-2" onSubmit={handleRegister}>
                <>
                    <TextFields
                        autoFocus={true}
                        name={'name'}
                        id={'name'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Nombre'}
                        type={'text'}
                        value={values.name}
                        placeholder={'Nombre'}
                        hasError={error.name.hasError}
                        messageError={error.name.message}
                        onChange={handleChangeName}
                        background={'dark'}
                    />
                    <TextFields
                        name={'lastName'}
                        id={'lastName'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Apellido'}
                        type={'text'}
                        value={values.lastName}
                        placeholder={'Apellido'}
                        hasError={error.lastName.hasError}
                        messageError={error.lastName.message}
                        onChange={handleChangeLastName}
                        background={'dark'}
                    />
                    <TextFieldsPhone
                        name={'phone'}
                        id={'phone'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Teléfono  +56 9 9999 9999'}
                        value={values.phone}
                        placeholder={'Teléfono'}
                        hasError={error.phone.hasError}
                        messageError={error.phone.message}
                        onChange={handleChangePhone}
                        background={'dark'}
                    />
                    <TextFields
                        name={'email'}
                        id={'email'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Email'}
                        type={'text'}
                        value={values.email}
                        placeholder={'Email'}
                        hasError={error.email.hasError}
                        messageError={error.email.message}
                        onChange={handleChangeEmail}
                        background={'dark'}
                    />
                    <TextFields
                        name={'password'}
                        id={'password'}
                        path={
                            'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                        }
                        label={'Contraseña'}
                        type={'password'}
                        value={values.password}
                        placeholder={'Contraseña'}
                        hasError={error.password.hasError}
                        messageError={error.password.message}
                        onChange={handleChangePassword}
                        background={'dark'}
                    />

                    <div className="flex py-3">
                        <div className="flex items-center mt-2 ">
                            <input type="checkbox" onChange={handleChangeTerms} checked={values.terms} id={'term'} />
                            <label
                                htmlFor={'terms'}
                                className={`text-white font-semibold pl-2 pointer-events-none text-sm `}
                            >
                                {'Acepto términos y condiciones'}
                            </label>
                        </div>
                        <Link
                            to={`/terminos-condiciones?name=${values.name}&lastName=${values.lastName}&email=${values.email}&phone=${values.phone}&terms=${values.terms}`}
                            className={'mt-2'}
                        >
                            <label htmlFor={'terms'} className={`text-white  pl-2 pointer-events-none text-sm `}>
                                (<span className={`underline`}> Puedes leerlos aquí </span>)
                            </label>
                        </Link>
                    </div>
                </>
                {errorRegister && <p className="mb-6 text-base text-red-200">{errorRegister}</p>}
                <button
                    type="submit"
                    className={`w-full relative text-white px-4 py-4 rounded-lg text-lg mb-6 ${
                        !values.terms ? 'bg-gray-400' : 'bg-sm-integrate'
                    }`}
                    disabled={!values.terms}
                >
                    Registrarme
                </button>
            </form>
            <div className={`w-full text-center`}>
                <Link to="/login">
                    <p className={`text-sm text-white`}>¿Ya tienes cuenta?</p>
                </Link>
            </div>
            <div className={`w-full text-center pt-4 cursor-pointer`}>
                <Link to="/registro/codigo">
                    <p className={`text-sm text-white`}>¿Tienes un Codigo para Validar el Registro?</p>
                </Link>
            </div>
        </>
    );
};

export default FormSignUp;
